import { cn } from "@/lib/utils";

export interface ProofItem {
  label: string;
  /** Only "proven" may use the green hue — it must be server-verified truth. */
  status: "proven" | "pending" | "missing";
  detail?: string;
}

export interface ProofStackProps {
  items: ProofItem[];
  className?: string;
}

const DOT = {
  proven: "bg-flow-proven",
  pending: "bg-flow-attention",
  missing: "bg-flow-blocked",
} as const;

const WORD = { proven: "Proven", pending: "Pending", missing: "Missing" } as const;

/** Proof Stack — the evidence behind a load: scans, POD, signatures, snapshots. */
export function ProofStack({ items, className }: ProofStackProps) {
  return (
    <ul className={cn("flow-surface divide-y divide-border p-0", className)} aria-label="Proof stack">
      {items.map((item) => (
        <li key={item.label} className="flex items-start gap-3 px-4 py-3">
          <span aria-hidden className={cn("mt-1.5 h-2 w-2 shrink-0 rounded-full", DOT[item.status])} />
          <div className="min-w-0 flex-1">
            <p className="text-sm font-medium text-foreground">{item.label}</p>
            {item.detail && <p className="text-xs text-muted-foreground">{item.detail}</p>}
          </div>
          <span className="shrink-0 text-xs text-muted-foreground">{WORD[item.status]}</span>
        </li>
      ))}
    </ul>
  );
}

export default ProofStack;
